import { PageIdentifier, Routing } from '@/constants';
export const getModelPathFromPathname = (pathname) => {
    const pathParts = pathname.split('/');
    // '/merchandising/rules/collection/area` -> ['', 'merchandising', 'rules', 'collection', 'area']
    // we need to get 'rules' out of here
    if (pathParts.length > 2) {
        return pathParts[2];
    }
    if (pathname === Routing.MERCHANDISING_PATH) {
        return Routing.ROUTE_PATHS[PageIdentifier.HOME_DASHBOARDS];
    }
    if (pathParts.length > 1) {
        return pathParts[1];
    }
    return null;
};
/**
 * Type guard to check if a string is a valid Routing.RoutePath
 */
export const isValidModelPath = (path) => {
    if (!path)
        return false;
    return Object.values(Routing.ROUTE_PATHS).includes(path);
};
export const getValidatedModelPath = (pathname) => {
    const path = getModelPathFromPathname(pathname);
    return isValidModelPath(path) ? path : undefined;
};
